import { brandWordmark } from '@getslot/ui-tokens'
import styles from './wordmark.module.css'
import { cx } from './cx'

/** Слово «getslot» с оранжевой точкой; цвет слова берётся из `color` родителя. */
export function Wordmark({ className }: { className?: string }) {
  const { viewBox, word, dot } = brandWordmark
  return (
    <svg className={cx(styles.mark, className)} viewBox={viewBox} role="img" aria-label="GetSlot">
      <path d={word} fill="currentColor" />
      <circle className={styles.dot} cx={dot.cx} cy={dot.cy} r={dot.r} />
    </svg>
  )
}
